import { formatDate } from '../utils/date-fns';
import useStateMemo from './use-state-memo';
export default function useValueTexts(value, _ref) {
  var format = _ref.format;
  return useStateMemo(function () {
    if (!value) {
      return '';
    }
    var valueTexts = formatDate(value, format);
    return valueTexts;
  }, [value], function (prev, next) {
    return prev !== next;
  });
}